<template>
  <div :class="wrapperClass">
    <div>1x</div>
    <div v-html="product.img_html"></div>
    <div>{{ product.name }}</div>
    <div class="pack-item__variation">
      <template v-if="product.type === 'variable'">
        <select name="" id="" v-model.number="variation_id">
          <option v-for="(label,id) in product.attributeSummaries" :value="id">{{ label }}</option>
        </select>
      </template>
    </div>
    <div class="pack-item__price">{{
        Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0,
        }).format(product.price)
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPackChild",
  props: ['product', 'index','loop'],
  data() {
    return {
      variation_id: null,
    }
  },
  computed: {
    wrapperClass() {
      return this.loop === true ? 'pack-item__loop-grid' : 'pack-item__grid'
    },
  },
  watch: {
    variation_id(val) {
      this.$emit('variation-selected', {index: this.index, id: val})
    }
  },
  beforeMount() {
    if (this.product.type === 'variable') {
      this.variation_id = parseInt(Object.keys(this.product.attributeSummaries)[0])
    }
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1113px) {
  .pack-item__grid {
    div {
      &.pack-item__variation {
        grid-column-start: 3;
      }

      &.pack-item__price {
        grid-row: 2;
        grid-column: span 2;
      }
    }
  }
}

.pack-item__grid {
  display: grid;
  grid-template-columns: 1fr 1fr 7fr;
  align-items: center;
  grid-gap: 1rem;
  margin: 2rem 0;
  border-bottom: 1px solid;

  div {
    &:nth-child(3) {
      font-weight: bold;
    }

    ::v-deep {
      img {
        max-width: 50px;
      }
    }
  }
}

@media screen and (min-width: 1114px) {
  .pack-item__grid {
    grid-template-columns: 40px 60px 3fr 2fr 60px;
  }
}

// this css is used whithin product loops
.pack-item__loop-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 7fr;
  align-items: center;
  grid-gap: 1rem;
  margin: 1rem 0;
  border-bottom: 1px solid lightgrey;
  padding: 0 2rem;
  font-size: 80%;

  div {
    &.pack-item__variation {
      grid-column-start: 3;
    }

    &.pack-item__price {
      grid-row: 2;
      grid-column: span 2;
      display: none;
    }

    select {
      height: 30px;
      padding: .25rem;
    }

    &:nth-child(3) {
      font-weight: bold;
      display: none;
    }

    ::v-deep {
      img {
        max-width: 30px;
      }
    }
  }
}


</style>
